import { render } from "./S109151.vue?vue&type=template&id=1f128964"
const script = {}
script.render = render

export default script